import axios from 'axios';
const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });
api.interceptors.request.use(config => {
  const token = localStorage.getItem('tkn_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(res => res, err => {
  if (err.response?.status === 401) { localStorage.removeItem('tkn_token'); window.location.href = '/login'; }
  return Promise.reject(err);
});
export const login  = (data) => api.post('/auth/login', data);
export const getMe  = () => api.get('/auth/me');
export const getDashStats = () => api.get('/dashboard/stats');
export const getClients    = (params) => api.get('/clients', { params });
export const createClient  = (data) => api.post('/clients', data);
export const updateClient  = (id, data) => api.put(`/clients/${id}`, data);
export const deleteClient  = (id) => api.delete(`/clients/${id}`);
export const getLeads     = (params) => api.get('/leads', { params });
export const createLead   = (data) => api.post('/leads', data);
export const updateLead   = (id, data) => api.put(`/leads/${id}`, data);
export const convertLead  = (id) => api.post(`/leads/${id}/convert`);
export const deleteLead   = (id) => api.delete(`/leads/${id}`);
export const getProjects   = (params) => api.get('/projects', { params });
export const createProject = (data) => api.post('/projects', data);
export const updateProject = (id, data) => api.put(`/projects/${id}`, data);
export const getInvoices   = (params) => api.get('/invoices', { params });
export const createInvoice = (data) => api.post('/invoices', data);
export const updateInvoice = (id, data) => api.put(`/invoices/${id}`, data);
export const deleteInvoice = (id) => api.delete(`/invoices/${id}`);
export const downloadInvoicePDF = (id) => api.get(`/invoices/${id}/pdf`, { responseType: 'blob' });
export const getServers   = () => api.get('/servers');
export const createServer = (data) => api.post('/servers', data);
export const updateServer = (id, data) => api.put(`/servers/${id}`, data);
export const deleteServer = (id) => api.delete(`/servers/${id}`);
export const getSubscriptions   = (params) => api.get('/subscriptions', { params });
export const createSubscription = (data) => api.post('/subscriptions', data);
export const updateSubscription = (id, data) => api.put(`/subscriptions/${id}`, data);
export const deleteSubscription = (id) => api.delete(`/subscriptions/${id}`);
export default api;

// ── Services ──────────────────────────────────────────────
export const getServices    = ()      => api.get('/services').then(r=>r.data);
export const createService  = (data)  => api.post('/services',data).then(r=>r.data);
export const updateService  = (id,d)  => api.put('/services/'+id,d).then(r=>r.data);
export const deleteService  = (id)    => api.delete('/services/'+id).then(r=>r.data);
